import { useState } from "react";

export const useStepper = (totalSteps: number, initialStep = 0,) => {
  const [activeStep, setActiveStep] = useState(initialStep);

  const goToStep = (step: number) => {
    if (step >= 0 && step < totalSteps) {
      setActiveStep(step);
    }
  };

  return { activeStep, goToStep, setActiveStep };
};
